<div class='message-component'>{{message}} <mat-icon class='icon-component'>error</mat-icon></div>